const number = 18
const getters = {
  trim: () => (data) => {
    if (!data) {
      return data
    }

    if (data.length >= number) {
      return data.slice(0, number) + '...'
    }
    return data
  }
}

export default {
  namespaced: true,
  getters
}
